import { format } from 'date-fns'
import { useEffect } from 'react'
import { BOOKING_STEP } from 'components/BookingModal/constants'
import { GET_NOTIFIED_STEP } from 'components/GetNotifiedModal/constants'
import { Toast } from 'components/Toast'
import { DATETIME } from 'constants/datetime'
import { ROUTE } from 'constants/routes'

export const useExpertDetailParseDataFromUrlHook = ({
  availabilities,
  expertData,
  isGetNotifiedModalOpenFromUrl,
  isLoading,
  router,
  selectedDate,
  selectedDateFromUrl,
  selectedSessionIdFromUrl,
  setBookingStep,
  setGetNotifiedStep,
  setIsBookingModalOpen,
  setIsGetNotifiedModalOpen,
  setSelectedSession,
  userAuth,
}) => {
  useEffect(() => {
    if (selectedDateFromUrl && selectedSessionIdFromUrl) {
      const selectedSessionFromQuery = (expertData.sessions || []).find(
        ({ id }) => id.toString() === selectedSessionIdFromUrl
      )
      if (selectedSessionFromQuery) {
        setSelectedSession(selectedSessionFromQuery)
        setIsBookingModalOpen(true)
      } else {
        Toast.error('Your selected consultation is not available.')
        setBookingStep(BOOKING_STEP.SESSION_ERROR)
      }
      if (isLoading || availabilities.length === 0) {
        return
      }
      const selectedAvailabilityFromQuery = availabilities.find(
        ({ startAtUtc }) =>
          format(new Date(startAtUtc.isoFormat), DATETIME) ===
          format(selectedDate, DATETIME)
      )
      if (availabilities && !selectedAvailabilityFromQuery) {
        Toast.error('Your time is not available.')
        setBookingStep(BOOKING_STEP.AVAILABILITY_ERROR)
      } else {
        const selectedDateObject = new Date(selectedDateFromUrl)
        if (selectedDateObject) {
          if (userAuth?.isClientSignedIn) {
            router.push(
              ROUTE.SESSION_CHECKOUT({
                expertSessionId: selectedSessionFromQuery.id,
                date: selectedAvailabilityFromQuery.startAtUtc.isoFormat,
              })
            )
          } else {
            setBookingStep(BOOKING_STEP.AUTHENTICATION)
          }
        } else if (userAuth?.isClientSignedIn) {
          router.push(
            ROUTE.SESSION_CHECKOUT({
              expertSessionId: selectedSessionFromQuery.id,
              date: selectedAvailabilityFromQuery.startAtUtc.isoFormat,
            })
          )
        } else {
          setBookingStep(BOOKING_STEP.AUTHENTICATION)
        }
      }
    }
    if (isGetNotifiedModalOpenFromUrl) {
      setIsGetNotifiedModalOpen(true)
      setGetNotifiedStep(GET_NOTIFIED_STEP.SUBMIT)
    }
  }, [
    expertData,
    availabilities,
    selectedDate,
    isLoading,
    selectedDateFromUrl,
    selectedSessionIdFromUrl,
    isGetNotifiedModalOpenFromUrl,
    router,
    setSelectedSession,
    setIsBookingModalOpen,
    setBookingStep,
    setIsGetNotifiedModalOpen,
    setGetNotifiedStep,
    userAuth.isClientSignedIn,
    userAuth.user,
  ])
}
